import api from './api';

const aiModelService = {
  getModels: async () => {
    try {
      const response = await api.get('/api/ai-models');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getActiveModels: async () => {
    try {
      const response = await api.get('/api/ai-models/active');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getModel: async (id) => {
    try {
      const response = await api.get(`/api/ai-models/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createModel: async (modelData) => {
    try {
      const response = await api.post('/api/ai-models', modelData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateModel: async (id, modelData) => {
    try {
      const response = await api.put(`/api/ai-models/${id}`, modelData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteModel: async (id) => {
    try {
      const response = await api.delete(`/api/ai-models/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default aiModelService;
